import {
  getAuthTokenFromLocalStorage,
  parseJwt,
  removeAuthTokenFromLocalStorage,
  setAuthTokenFromLocalStorage,
} from "./utils";

class Auth {
  IsLoggedIn() {
    if (getAuthTokenFromLocalStorage()) {
      return true;
    }
    return false;
  }

  LogOut() {
    removeAuthTokenFromLocalStorage();
    window.location.reload();
  }

  SetLogin(token: string) {
    setAuthTokenFromLocalStorage(token);
  }

  GetUser(): {
    r: string[]
    uid: string
  } | null {
    if (!this.IsLoggedIn()) {
      this.LogOut();
      return null;
    }
    const token = getAuthTokenFromLocalStorage();
    const parsed = parseJwt(token);
    // ! IF EXPIRED INCORRECT
    if (new Date(parsed.exp * 1000) < new Date()) {
      this.LogOut();
      return null;
    }

    const usr = parsed.p;
    if (!usr) {
      this.LogOut();
      return null;
    }
    return usr;
  }

  GetUserRoles() {
    const usr = this.GetUser();
    if (!usr) {
      return null;
    }
    return usr.r;
  }

  IsUserType(type: UserType) {
    const roles = this.GetUserRoles();
    if (!roles) return false;
    return roles.includes(type);
  }
}

export enum UserType {
  Default = "user",
  Manager = "manager",
  Admin = "admin",
}

export const auth = new Auth();
